export default {
  editor_chatTab_text_messagePlaceholderNamed: 'Mensaje {peer}',
  editor_chatTab_text_messagePlaceholder_meBot: 'Env\u00edese un mensaje',
  mediaTray_chatTab_notification_stickerMessage:
    'envi\u00f3 un sticker - {stickerName} ',
};
